import { useState } from "react";
import { ClipboardCheck, Users, Award } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";
import TestSelfAssessment from "./TestSelfAssessment";
import TestPeerReviewed from "./TestPeerReviewed";
import TestCertified from "./TestCertified";

/**
 * Test shell — three tabs: Self Assessment, Peer Reviewed, Quran Fluency Certified.
 */
export default function TestMode({ module: m, progress, onAttemptSaved, onRunningChange, hasSections, selectedSection, sectionUnlocked }) {
  const { t } = useI18n();
  const [tab, setTab] = useState("self"); // "self" | "peer" | "certified"
  const [running, setRunning] = useState(false);

  const setRunningState = (v) => { setRunning(v); onRunningChange && onRunningChange(v); };

  return (
    <>
      <div className="rounded-2xl bg-white border border-[#E7E0D2] p-2 flex items-center gap-2" data-testid="test-tabs">
        <button
          data-testid="test-tab-self"
          onClick={() => setTab("self")}
          className={`flex-1 inline-flex items-center justify-center gap-2 px-3.5 py-2 rounded-full text-sm font-medium transition ${
            tab === "self" ? "bg-[#ECFDF5] text-[#064E3B] border border-[#A7F3D0]" : "text-[#4B5563] hover:text-[#1F2937] border border-transparent"
          }`}>
          <ClipboardCheck className="w-4 h-4" /> <span className="hidden sm:inline">{t("rd.test_tab_self_assessment")}</span>
        </button>
        <button
          data-testid="test-tab-peer"
          onClick={() => !running && setTab("peer")}
          disabled={running}
          title={running ? "Finish or reset the current test first" : undefined}
          className={`flex-1 inline-flex items-center justify-center gap-2 px-3.5 py-2 rounded-full text-sm font-medium transition disabled:opacity-40 disabled:cursor-not-allowed ${
            tab === "peer" ? "bg-[#ECFDF5] text-[#064E3B] border border-[#A7F3D0]" : "text-[#4B5563] hover:text-[#1F2937] border border-transparent"
          }`}>
          <Users className="w-4 h-4" /> <span className="hidden sm:inline">{t("rd.test_tab_peer_reviewed")}</span>
        </button>
        <button
          data-testid="test-tab-certified"
          onClick={() => !running && setTab("certified")}
          disabled={running}
          title={running ? "Finish or reset the current test first" : undefined}
          className={`flex-1 inline-flex items-center justify-center gap-2 px-3.5 py-2 rounded-full text-sm font-medium transition disabled:opacity-40 disabled:cursor-not-allowed ${
            tab === "certified" ? "bg-[#ECFDF5] text-[#064E3B] border border-[#A7F3D0]" : "text-[#4B5563] hover:text-[#1F2937] border border-transparent"
          }`}>
          <Award className="w-4 h-4" /> <span className="hidden sm:inline">{t("rd.test_tab_certified")}</span>
        </button>
      </div>

      <div className="mt-4">
        {tab === "self" && <TestSelfAssessment module={m} progress={progress} onAttemptSaved={onAttemptSaved} onRunningChange={setRunningState}
          hasSections={hasSections} selectedSection={selectedSection} sectionUnlocked={sectionUnlocked} />}
        {tab === "peer" && <TestPeerReviewed module={m} />}
        {tab === "certified" && <TestCertified module={m} />}
      </div>
    </>
  );
}
